import _ from 'lodash'
import {
	shortenedAndUnshortened
} from 'scoreboard/components/format-value'
import { datasetAggregationFormatter } from './dataset-formatter'
import * as formatterConverters from './formatter-converters'
import initiativeFormatter from './initiative-formatter'
import scorecardFormatter from './scorecard-formatter'
import scorecardSeriesDataType from './scorecard-series-data-type'
const { toShortened, toUnshortened } = formatterConverters
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, YES_NO } = DataType

/**
 * Build the formatter the charts library should use for data values
 *
 * @param {Boolean} forChart if true, the formatter is for a chart; if false, it
 * is for a chart data table
 */
export default function(serie, chartData, labelSettings, forChart = true) {
	let formatter
	const precision = _.get(labelSettings, 'precision')
	const domainType = _.get(serie, 'source.domainType')

	if (domainType === 'dataset') {
		formatter = datasetAggregationFormatter({
			aggregation: serie.source.aggregation,
			chartData
		}, labelSettings || {})
	} else if (domainType === 'scorecard-item') {
		let scorecardItem = chartData.scorecards(serie.source.scorecardItemId)
		let scorecardSeries = serie.source.dataProperty

		const seriesGroupedByStackBy = _(chartData.plots())
			.flatMap(p => p.series)
			.filter(s => !_.isNil(s.stackBy))
			.groupBy(s => s.stackBy)
			.values()
			.value()
		const isStacked = _.some(seriesGroupedByStackBy, g => g.length > 1)
		const seriesDataType = scorecardSeriesDataType(serie, scorecardItem)
		// #47840 make sure "labelSettings" isn't mutated, since it's shared
		// among all series
		formatter = scorecardFormatter(scorecardItem, scorecardSeries, _.extend({}, labelSettings, {
			// TODO not sure overrideDataType will be necessary anymore; probably will
			// be done on the server?

			// #44132 Stacked yes/no metrics should use numeric axes
			overrideDataType: seriesDataType === YES_NO && isStacked ?
				NUMBER : seriesDataType
		}))
	} else if (domainType === 'initiative') {
		let init = chartData.initiatives(serie.source.initiativeId)
		let dataProperty = serie.source.dataProperty

		formatter = initiativeFormatter(init, dataProperty, precision)
	}

	if (!formatter) {
		formatter = function (value) {
			return shortenedAndUnshortened({
				value,
				precision,
				dataType: NUMBER
			})
		}
	}

	// #40181 abbreviate the values if specified in the label settings or if there
	// are no label settings
	// #42099 lines, bars, and areas do not have formatting settings, but their
	// serie formatters should not abbreviate the values. As well, we always want
	// the data table to abbreviate data
	const abbreviate = _.get(labelSettings, 'abbreviateChartedValues')
	const shorten = ((_.isNil(abbreviate) || abbreviate) &&
		![ 'line', 'bar', 'area' ].includes(serie.type)) || !forChart
	serie.formatter = shorten ? toShortened(formatter) : toUnshortened(formatter)
	serie.shortenedAndUnshortenedFormatter = formatter
}